module.exports = __webpack_public_path__ + "static/media/Lidia.260ad052.jpeg";